import store from '@/store';
// import middleware from './middleware';
import NotFound from '@/views/NotFound.vue';
import Login from '@/views/Login.vue';
import Home from '@/views/Home.vue';
import Pratiche from '@/views/Pratiche.vue';
import Clienti from '@/views/Clienti.vue';
import Accordi from '@/views/Accordi.vue';
import MaterialeInformativo from '@/views/MaterialeInformativo.vue';
import Impostazioni from '@/views/Impostazioni.vue';
import ContrattiDiServizio from '@/views/ContrattiDiServizio.vue';
import Conteggi from '@/views/Conteggi.vue';

const routes = [
	{
		// will match everything
		path: '*',
		name: 'not_found',
		component: NotFound
	},
	
	{
		path: '/impostazioni',
		name: 'impostazioni',
		component: Impostazioni,
		// beforeEnter: (to, from, next) => {
		// 	if (store.getters['auth/isAccountManager']) next()
		// 	else next({ name: 'not_found'})
		// }
	},
	
	{
		path: '/login',
		name: 'login',
		component: Login,
		beforeEnter: (to, from, next) => {
			if (store.getters['auth/isAuthenticated']) {
				if (store.getters['auth/isAccountManager']) next({ name: 'clienti'})
				else if (store.getters['auth/isCoordinatore']) next({ name: 'pratiche'})
				else if (store.getters['auth/isCliente']) next({ name: 'home'})
				
			}
			else next();
		}
	},
	
	{
		path: '/',
		name: 'home',
		component: Home,
		beforeEnter: (to, from, next) => {
			if (store.getters['auth/isCliente']) next()
			else next({ name: 'accordi' })
		}
	},
	
	{
		path: '/materiale-informativo',
		name: 'materiale_informativo',
		component: MaterialeInformativo,
		beforeEnter: (to, from, next) => {
			if (store.getters['auth/isCliente']) {
				if (store.getters['auth/user'].cliente.tipologia == 'Azienda') next({ name: 'pratiche'})
				else next()
			}
			else if (store.getters['auth/isCoordinatore']) next({ name: 'pratiche'})
			else next({ name: 'clienti' })
		}
	},
	
	{
		path: '/clienti',
		name: 'clienti',
		component: Clienti,
		beforeEnter: (to, from, next) => {
			if (store.getters['auth/isAccountManager']) next()
			else if (store.getters['auth/isCoordinatore']) next({ name: 'pratiche'})
			else if (store.getters['auth/isCliente']) {
				if (store.getters['auth/user'].cliente.tipologia == 'Azienda') next({ name: 'pratiche'})
				else next({ name: 'home'})
			}
		}
	},
	
	{
		path: '/pratiche',
		name: 'pratiche',
		component: Pratiche
	},
	
	{
		path: '/contratti-di-servizio',
		name: 'contratti_di_servizio',
		component: ContrattiDiServizio,
		beforeEnter: (to, from, next) => {
			if (store.getters['auth/isAccountManager'] || store.getters['auth/isCliente']) next()
			else next({ name: 'not_found'})
		}
	},
	
	{
		path: '/accordi',
		name: 'accordi',
		component: Accordi,
		beforeEnter: (to, from, next) => {
			if (store.getters['auth/isAccountManager']) next()
			else if (store.getters['auth/isCoordinatore']) next({ name: 'pratiche'})
			else if (store.getters['auth/isCliente']) {
				if (store.getters['auth/user'].cliente.tipologia == 'Azienda') next({ name: 'pratiche'})
				else next({ name: 'home'})
			}
		},
	},

	{
		path: '/conteggi',
		name: 'conteggi',
		component: Conteggi,
		beforeEnter: (to, from, next) => {
			if (store.getters['auth/isAccountManager']) next()
			else next({ name: 'not_found'})
		}
	},
];

export default routes;
